import { render, staticRenderFns } from "./ProcessSafety.vue?vue&type=template&id=6925ce4e&scoped=true"
import script from "./ProcessSafety.vue?vue&type=script&lang=js"
export * from "./ProcessSafety.vue?vue&type=script&lang=js"
import style0 from "./ProcessSafety.vue?vue&type=style&index=0&id=6925ce4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925ce4e",
  null
  
)

export default component.exports